import { http } from '@pendo/http';

export const segmentsApi = '/api/s/_SID_/segment';

export async function fetchSegment (id) {
    return http.get(`${segmentsApi}/${id}`).then((res) => res.data);
}

export async function fetchSegments () {
    return http.get(segmentsApi).then((res) => res.data);
}

export async function createSegment (segment) {
    return http.post(segmentsApi, segment).then((res) => res.data);
}

export async function updateSegment (segment) {
    return http.put(`${segmentsApi}/${segment.id}`, segment).then((res) => res.data);
}

export async function deleteSegment (segment) {
    return http.delete(`${segmentsApi}/${segment.id}`);
}

export async function getSegmentsCreatedByMe () {
    return http.get(segmentsApi, { params: { createdByMe: true } }).then((res) => res.data);
}
